module.exports = __webpack_public_path__ + "img/content-bg.fefd9aa3.png";